export function showSuccess(title, msg, icon) {
  initToast();
  window.iziToast.success({
    icon: icon,
    title: title,
    message: msg
  });
}

export function showError(title, msg, icon) {
  initToast();
  window.iziToast.error({
    icon: icon,
    title: title,
    message: msg
  });
}

export function showWarning(title, msg, icon) {
  initToast();
  window.iziToast.warning({
    icon: icon,
    title: title,
    message: msg
  });
}

export function showInfo(title, msg, icon) {
  initToast();
  window.iziToast.info({
    icon: icon,
    title: title,
    message: msg
  });
}

function initToast() {
  window.iziToast.settings({
    timeout: 5000, // default timeout
    resetOnHover: true,
    // icon: '', // icon class
    transitionIn: "flipInX",
    transitionOut: "flipOutX",
      position: "topCenter", // bottomRight, bottomLeft, topRight, topLeft, topCenter, bottomCenter, center
    onOpen: function() {},
    onClose: function() {}
  });
}
